import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import MasonryGallery from "../../components/MasonryGallery";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import Notification from "../../components/Notification";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import ImageGallery from "../../components/ImageGallery";

import BlockLeftImage from "../../components/BlockLeftImage";
import OfferEdes from "../../components/view/OfferEdes";
import SemanasInternacionales from "../../components/SemanasInternacionales";

function Edes() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <center>
                    <div className="icon200">
                      <img
                        src="https://www.utpl.edu.ec/maestrias/sites/default/files/escuela-de-negocio.png"
                        alt="utpl"
                      ></img>{" "}
                    </div>
                  </center>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="relative">
              <Notification
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                }
              ></Notification>

              <ModalFixed
                title="Proceso de matrícula 📝"
                color="#5854a7"
                content={
                  <>
                    <div className="width400">
                      <ImageGallery
                        gallery={item.field_gallery1}
                      ></ImageGallery>
                    </div>
                  </>
                }
              ></ModalFixed>
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/escuela-negocios">
                    UTPL Escuela de Negocios
                  </NavLink>
                </>
              }
            ></Breadcumbs>
            <center>
              <div className="icon200">
                <img
                  src="https://www.utpl.edu.ec/maestrias/sites/default/files/escuela-negocios-colo.png"
                  alt="edes utpl"
                ></img>
              </div>
            </center>
            <div
              className="layout8"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque2,
              }}
            />
            <OfferEdes></OfferEdes>
            <div className="margin">
              <BlockLeftImage
                src={item.field_imagen4}
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                }
              ></BlockLeftImage>
            </div>
            <SemanasInternacionales></SemanasInternacionales>
            <div className="icon200 layout8 padding">
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque5,
                }}
              />

              <MasonryGallery variant="logos" gallery={item.field_gallery2}>
                {" "}
              </MasonryGallery>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-edes.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <div className="margin">
        <ConectUs
          instagram="https://www.instagram.com/utplescueladenegocios"
          linkedin="https://www.linkedin.com/company/utplescueladenegocios"
          tiktok="https://www.tiktok.com/@utplescueladenegocios"
          facebook="https://www.facebook.com/utplescuelanegocios/"
        ></ConectUs>
      </div>

      <div className="margin">
        <BannerGeneral></BannerGeneral>{" "}
      </div>
    </>
  );
}

export default Edes;
